import { render, staticRenderFns } from "./substantiate-claims.page.vue?vue&type=template&id=7e447c30&"
import script from "./substantiate-claims.page.vue?vue&type=script&lang=ts&"
export * from "./substantiate-claims.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports